import React from "react"
import { Label, LargeTotalEntry, LargeValue } from "./OrderList"

type Props = {
  label: string
  value: string | number
}

const LargeTotal = ({ label, value }: Props) => {
  return (
    <LargeTotalEntry>
      <Label>{label}</Label>
      <LargeValue>{value}</LargeValue>
    </LargeTotalEntry>
  )
}

export default LargeTotal
